module.exports = __webpack_public_path__ + "pic/25.8c805d93.png";